<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Name</label>
          <el-input type="text"
                 name="name"
                 clearable
                 placeholder="Name"
                 :disabled="!canEdit"
                 v-validate="modelValidations.name"
                 v-model="edit.name" />
          <small class="text-danger" v-show="errors.has('name')">
            {{ getError('name') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>State</label>
          <el-select name="state"
                     class="select"
                     size="large"
                     :disabled="!canEdit"
                     placeholder="State"
                     v-validate="modelValidations.state"
                     data-vv-as="state"
                     v-model="edit.state">
            <el-option v-for="option in states"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('state')">
            {{ getError('state') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Timezone</label>
          <el-select name="state"
                     class="select"
                     size="large"
                     :disabled="!canEdit"
                     placeholder="Timezone"
                     v-validate="modelValidations.timezone"
                     data-vv-as="timezone"
                     v-model="edit.timezone">
            <el-option v-for="option in timezones"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('timezone')">
            {{ getError('timezone') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Zip Codes</label>
          <div class="row">
            <div class="col-md-8">
              <el-input type="text"
                     name="zipCode"
                     :disabled="!canEdit"
                     data-vv-as="zip code"
                     data-vv-delay="500"
                     placeholder="Add Zip Code"
                     v-validate="modelValidations.zipCode"
                     v-model="zipCode" />
            </div>
            <div class="col-md-4">
              <button type="button" v-if="canEdit" @click="addZipCode" class="btn btn-fill btn-info btn-add pull-left">+</button>
                <a href="https://m.usps.com/m/ZipLookupAction?search=city" target="_blank" rel=”noopener”>
                  <el-tooltip class="item space-icon pull-left" effect="dark" content="Click here to look up zipcodes." placement="top-start">
                    <img class="icon" src="static/img/icon-log.png"/>
                  </el-tooltip>
                </a>
            </div>
          </div>
          <small class="text-danger" v-show="errors.has('zipCode')">
            {{ getError('zipCode') }}
          </small>
        </div>
        <table class="table-city-data">
          <colgroup>
            <col style="width:85%">
            <col style="width:15%">
          </colgroup>
          <tr v-for="zipCode in edit.zipCodes">
            <td>{{ zipCode }}</td>
            <td>
              <p-button type="danger" v-if="canEdit" size="sm" icon @click="deleteZipCode(zipCode)">
                <i class="fa fa-times"></i>
              </p-button>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Counties</label>
          <div class="row">
            <div class="col-md-8">
              <el-input type="text"
                     name="county"
                     :disabled="!canEdit"
                     data-vv-as="county"
                     data-vv-delay="500"
                     placeholder="Add County"
                     v-validate="modelValidations.county"
                     v-model="county" />
            </div>
            <div class="col-md-4">
              <button type="button" @click="addCounty" v-if="canEdit" class="btn btn-fill btn-info btn-add pull-left">+</button>
                <a href="https://txcip.org/tac/census/places.php" target="_blank" rel=”noopener”>
                  <el-tooltip class="item space-icon pull-left" effect="dark" content="Click here to look up counties." placement="top-start">
                    <img class="icon" src="static/img/icon-log.png"/>
                  </el-tooltip>
                </a>
            </div>
          </div>
          <small class="text-danger" v-show="errors.has('county')">
            {{ getError('county') }}
          </small>
        </div>
        <table class="table-city-data">
          <colgroup>
            <col style="width:85%">
            <col style="width:15%">
          </colgroup>
          <tr v-for="county in edit.counties">
            <td>{{ county }}</td>
            <td>
              <p-button type="danger" v-if="canEdit" size="sm" icon @click="deleteCounty(county)">
                <i class="fa fa-times"></i>
              </p-button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row" v-if="isEditCity">
      <div class="col-md-6">
        <div class="form-group">
            <label>Travel Charge - Service Zone</label>
            <el-select name="serviceAreaId"
                        class="select"
                        size="large"
                        :disabled="!canEditServiceZone"
                        placeholder="Service Area"
                        v-validate="modelValidations.serviceAreaId"
                        data-vv-as="serviceAreaId"
                        v-model="edit.serviceAreaId">
              <el-option v-for="option in serviceAreas"
                          class="select"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label">
              </el-option>
            </el-select>
          <small class="text-danger" v-show="errors.has('serviceAreaId')">
              {{ getError('serviceAreaId') }}
            </small>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
            <label>Service Zone Center (miles)</label>
            <vue-numeric
                name="distanceToServiceArea"
                :minus="false"
                :disabled="editLock"
                v-validate="modelValidations.price"
                class="twenty-five-percent el-input__inner"
                placeholder="Distance to Service Area"
                data-vv-as="distanceToServiceArea"
                v-model="edit.distanceToServiceArea"></vue-numeric>
        </div>
      </div>
      <div class="col-md-1 btn-lock-div">
        <el-tooltip v-if="editLock" style="margin-top: 2px;" class="item space-icon pull-left" effect="dark" content="Click to unlock Service Area edits" placement="top-start">
          <button type="button" @click="toggleEditLock"  class="btn btn-lock btn-info pull-right">
            <i>
              <lock-open/>
            </i>
          </button>
        </el-tooltip>
        <el-tooltip v-if="!editLock"  style="margin-top: 2px;" class="item space-icon pull-left" effect="dark" content="Click to Lock Service Area edits" placement="top-start">
          <button type="button" @click="toggleEditLock"  class="btn btn-lock btn-info pull-right">
            <i>
              <lock-open-variant/>
            </i>
          </button>
        </el-tooltip>
      </div>
    </div>
    <div class="row">
      <div v-if="isEditCity" class="col-md-12">
        <label>Travel Charge Amount: ${{travelChargeAmount}}</label>
        <el-input
            :disabled="true"
            size="45"
            :placeholder="travelChargeCalculation" />
      </div>
    </div>
    <div class="row pull-right" style="margin-top: 15px;" v-if="canEdit">
      <div class="col-md-12">
        <button type="button" :disabled="isSubmitDisabled" @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {notifySuccess, notifyError, kvpsForSelectFromArray} from 'src/utilities/utils'
  import PButton from 'src/components/UIComponents/Button.vue'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import VueNumeric from 'vue-numeric'
  import {sync} from 'vuex-pathify'
  import LockOpen from 'vue-material-design-icons/LockOpen'
  import LockOpenVariant from 'vue-material-design-icons/LockOpenVariant'
  import {OK} from 'http-status-codes'

  export default{
    props: ['data'],
    components: {
      PButton,
      VueNumeric,
      LockOpen,
      LockOpenVariant,
    },
    computed: {
      edit: sync('cities@edit'),
      ...mapGetters({
        states: 'states',
        putPayload: 'cities/putPayload',
        postPayload: 'cities/postPayload',
        serviceAreas: 'serviceAreas/kvpsForSelect'
      }),
      travelChargeCalculation() {
        return `(${this.edit.distanceToServiceArea} miles - ${this.travelChargeRadius} miles free) x ($${this.travelChargeRate} per mile) = $${this.travelChargeAmount}`
      },
      canEdit() {
        return this.$can('edit', Permissions.CITIES)
      },
      canEditServiceZone() {
        return this.canEdit && !this.editLock
      },
      isEditCity() {
        return this.data && this.data.id
      },
      isSubmitDisabled() {
        return this.isProcessing
      }
    },
    data() {
      return {
        travelChargeAmount: 0,
        travelChargeRate: 0,
        travelChargeRadius: 0,
        constants: Constants,
        timezones: kvpsForSelectFromArray(['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles']),
        zipCode: null,
        county: null,
        editLock: true,
        citySaved: false,
        isProcessing: false,
        modelValidations: {
          name: {
            required: true,
            max: 64
          },
          state: {
            required: true
          },
          zipCode: {
            digits: 5
          },
          county: {
            max: 64
          },
          serviceAreaId: {
            required: this.isEditCity
          }
        }
      }
    },
    methods: {
      deleteZipCode(zipCode) {
        this.$store.commit('cities/deleteZipCode', zipCode)
      },
      deleteCounty(county) {
        this.$store.commit('cities/deleteCounty', county)
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      addZipCode() {
        this.$validator.validate('zipCode', this.zipCode).then(async isValid => {
          if (isValid && this.zipCode) {
            this.$store.commit('cities/addZipCode', this.zipCode)
            this.zipCode = null
          }
        })
      },
      toggleEditLock() {
        this.editLock = !this.editLock
      },
      addCounty() {
        if (this.county && this.county.length > 0) {
          this.$store.commit('cities/addCounty', this.county)
          this.county = null
        }
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          let response
          if (this.isEditCity) {
            response = await this.$store.dispatch('put', this.putPayload)
          } else {
            response = await this.$store.dispatch('post', this.postPayload)
          }

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            this.$store.commit('cities/resetEdit')
            if (response.data) {
              this.$eventHub.$emit('citySaved', response.data)
            }
            this.citySaved = true
            this.$emit('close')
            notifySuccess(this, 'City Saved Successfully')
          } else if (response.result === Constants.RETURN_CODES.ERROR) {
            notifyError(this, 'Error Saving City', response.errors)
          }
        }
        this.isProcessing = false
      }
    },
    mounted() {
      if (!this.isEditCity) {
        this.edit.state = Constants.ATS.DEFAULT.STATE
        this.edit.timezone = Constants.ATS.DEFAULT.TIMEZONE
      }

      if (_.get(this.data, 'name')) {
        this.edit.name = this.data.name
      }
    },
    async beforeMount() {
      this.$store.commit('cities/resetEdit')
      await this.$store.dispatch('serviceAreas/fetchAll')

      if (this.isEditCity) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.CITIES,
          id: this.data.id
        })

        if (OK === response.status) {
          this.$store.commit('cities/edit', response.data)
          const travelChargeResponse = await this.$store.dispatch('cities/fetchTravelCharge')
          const travelChargeParametersResponse = await this.$store.dispatch('cities/fetchTravelChargeParameters')
          if (OK === travelChargeResponse.status && OK === travelChargeParametersResponse.status) {
            const tcParams = travelChargeParametersResponse.data
            this.travelChargeAmount = travelChargeResponse.data
            this.travelChargeRate = tcParams.travelChargeRate
            this.travelChargeRadius = tcParams.travelChargeRadius
          } else {
            notifyError(this, 'Failed to get Travel Charge details.')
          }
        }
      }
    },
    destroyed() {
      if (!this.citySaved) {
        this.$eventHub.$emit('noCitySaved')
      }
    }
  }
</script>

<style scoped>
  .space-icon {
    padding-top: 5px !important;
  }
  label {
    display: block;
  }
  .table-city-data {
    width: 100%;
    margin-bottom: 12px;
    border: 1px solid #d3dce6;
  }
  .table-city-data tr {
    border-bottom: 1px solid #d3dce6;
  }
  .table-city-data tr td:first-child {
    padding: 3px 12px;
  }
  .btn-add {
    margin: 3px 15px 0 0;
    padding: 7px 12px;
  }
  .btn-lock-div {
    padding-top: 28px;
  }
  .btn-lock {
    margin: 0 15px 0 0;
    padding: 5px 7px;
  }
</style>
